import { MapPin } from "lucide-react";

/** Time-slot buttons grouped by clinic location (online slots render as one flat group). */
export const GroupedSlotGrid = ({ slots, selected, onSelect, testIdPrefix, gridClass = "grid grid-cols-3 sm:grid-cols-4 gap-2" }) => {
  const groups = [];
  slots.forEach((s) => {
    const label = s.location || null;
    let g = groups.find((x) => x.label === label);
    if (!g) {
      g = { label, slots: [] };
      groups.push(g);
    }
    g.slots.push(s);
  });

  return (
    <div className="space-y-5">
      {groups.map((g) => (
        <div key={g.label || "all"}>
          {g.label && (
            <div className="flex items-center gap-1.5 mb-2" data-testid={`slot-group-${g.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <MapPin className="w-3.5 h-3.5 text-[#5E8B7E] shrink-0" />
              <span className="text-sm font-semibold text-slate-700">{g.label}</span>
              <span className="text-xs text-slate-400">· {g.slots[0]?.time < "14:00" ? "Morning" : "Evening"}</span>
            </div>
          )}
          <div className={gridClass}>
            {g.slots.map((s) => (
              <button
                key={s.time}
                data-testid={`${testIdPrefix}-${s.time.replace(":", "")}`}
                disabled={!s.available}
                onClick={() => onSelect(s.time)}
                className={`py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  selected === s.time
                    ? "bg-[#5E8B7E] text-white shadow"
                    : s.available
                    ? "bg-white border border-[#D9E4E1] text-slate-700 hover:border-[#5E8B7E]"
                    : "bg-[#F4F7F6] text-slate-300 cursor-not-allowed line-through"
                }`}
              >
                {s.time}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
